import React from 'react';
import PropTypes from 'prop-types';

import { isEnterprisePlatform } from '../../../utils/platformHelper';

import { DefaultLogo } from './DefaultLogo';
import { EnterpriseLogo } from './EnterpriseLogo';
import { defaultLogoPropTypes } from './logoPropTypes';

/**
 * Routes to DefaultLogo or EnterpriseLogo based on platform.
 * Header always uses DefaultLogo (enterprise branding is not shown in the app header).
 */
export const Logo = (props) => {
  const enterprisePlatform = isEnterprisePlatform() && props.variant !== 'header';

  if (enterprisePlatform) {
    return <EnterpriseLogo {...props} />;
  }

  return <DefaultLogo {...props} />;
};

Logo.propTypes = defaultLogoPropTypes;
